import type { FC } from 'react';

import type { SegmentEntityWithIdNormalized } from '@iconik-io/shared-lib/src/redux/entities/normalized/segment';

import {
  SEGMENT_TYPE_COMMENT,
  SEGMENT_TYPE_GENERIC,
  SEGMENT_TYPE_TAG,
} from '../segment_form/constants';
import { SegmentValueComment } from './segment_value_comment';
import { SegmentValueGeneric } from './segment_value_generic';
import { SegmentValueTag } from './segment_value_tag';

type Props = {
  segment: SegmentEntityWithIdNormalized;
};

export const SegmentValue: FC<Props> = ({ segment }) => {
  if (segment.segment_type === SEGMENT_TYPE_COMMENT) {
    return (
      <SegmentValueComment
        segment={segment}
        value={segment.segment_text ?? ''}
      />
    );
  }

  if (segment.segment_type === SEGMENT_TYPE_TAG) {
    return <SegmentValueTag value={segment.metadata?._gcvi_tags ?? []} />;
  }

  if (segment.segment_type === SEGMENT_TYPE_GENERIC) {
    return (
      <SegmentValueGeneric segment={segment} value={segment.metadata ?? {}} />
    );
  }

  return null;
};
